<template>
  <div class="flex flex-col items-center justify-center p-32">
    <RevIllustration
      alt=""
      :height="276"
      imageClassNames="m-44"
      sizes="40px"
      src="/img/customer-care/technical-error.svg"
      :width="286"
    />
    <div class="flex flex-col items-center space-y-10">
      <h2 class="body-1-bold">{{ i18n(translations.title) }}</h2>
      <p class="text-center">{{ i18n(translations.description) }}</p>

      <RevButton size="small" variant="primary" @click="$emit('try-again')">
        {{ i18n(translations.buttonLabel) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'
import { RevIllustration } from '@ds/components/Illustration'

import translations from './TechnicalIssueBlock.translations'

defineEmits(['try-again'])
const i18n = useI18n()
</script>
